import s from './FilterItem.module.sass'

import React, { FC, useRef } from 'react'
import Link from 'next/link'

import { useAppSelector } from '@app/model/store'
import { useOnScreen } from '@widgets/Restaurant/Booking/lib/helper'
import { findDataTagForAnalyticBySlug } from '@features/Restaurant/RestaurantFilters/helpers/helper'
import { TypeQuickFilter } from '@shared/api/middleware/mappingAPI/city/types'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { Text } from '@shared/ui/Typography/Text'
import { EGG } from '@shared/api/analytics'

interface Props {
  data: TypeQuickFilter
}

type ImageWithSrc = {
  desktop: { src: string }
  mobile: { src: string }
}

const FilterItem: FC<Props> = ({ data }) => {
  const { isMobile } = useClientResponsive()

  const storeCityRead = useAppSelector((store) => store.global.cityRead)

  const wrapper = useRef<HTMLAnchorElement>(null)
  const rootForIntersectionObserver = wrapper.current?.parentElement?.parentElement ?? null
  const visible60 = useOnScreen(wrapper, { threshold: 0.6, root: rootForIntersectionObserver })
  const visible70 = useOnScreen(wrapper, { threshold: 0.7, root: rootForIntersectionObserver })
  const visible80 = useOnScreen(wrapper, { threshold: 0.8, root: rootForIntersectionObserver })
  const visible90 = useOnScreen(wrapper, { threshold: 0.9, root: rootForIntersectionObserver })

  const getOpacityValue = () => {
    const isShowContent = window.innerWidth <= 970 || isMobile || visible90

    if (isShowContent) return 1
    else if (visible80) return 0.6
    else if (visible70) return 0.4
    else if (visible60) return 0.2
    else return 0
  }

  const handleClick = () => {
    const dataTag = findDataTagForAnalyticBySlug(data.slug)

    EGG.common.quick_filter_click({
      filter_apply_type: dataTag.type,
      filter_apply_value: data.slug,
    })
  }

  const image = data.image as unknown as ImageWithSrc | null
  const imageSrc = image ? image[isMobile ? 'mobile' : 'desktop']?.src : ''
  const href = `/${storeCityRead?.slug}/restaurants/restaurant_list/${data.slug}`

  // картинки с белым фоном
  const isMultiplyBlend = data.slug === 'european_cuisine' || data.slug === 'fish_restaurants' ? true : false

  // с дефисом не переносим
  const isNowrap = data.slug === 'buisness_lunch' ? true : false

  // убираем слово "кухня" для мобилки
  const filteredName = (thisName) => thisName.replace('кухня', '').trim()

  return (
    <Link
      href={href}
      onClick={handleClick}
      className={s.filter}
      key={data.slug}
      ref={wrapper}
      title={data.name}
      scroll={false}>
      <div className={s.imageWrapper}>
        <img
          src={imageSrc}
          alt={data.name}
          className={s.imageElem}
          data-blend={isMultiplyBlend ? 'multiply' : undefined}
          style={{
            opacity: getOpacityValue(),
            width: isMobile ? '100px' : '130px',
            height: isMobile ? '100px' : '130px',
            objectFit: 'cover',
          }}
        />

        {isMobile && (
          <Text
            sizes={'S'}
            className={s.title}
            tag={'h4'}
            style={{ opacity: getOpacityValue() }}
            data-nowrap={isNowrap ? 'nowrap' : undefined}>
            {filteredName(data.name)}
          </Text>
        )}
      </div>

      {!isMobile && (
        <Text sizes={'S'} className={s.title} tag={'h4'} style={{ opacity: getOpacityValue() }}>
          {data.name}
        </Text>
      )}
    </Link>
  )
}

export default FilterItem
